jQuery(document).ready(function(){
    //console.log("anchor script running");
    
      var offsetamount = 200;
  
      if (location.hash !== "") {
          console.log("has hash in url...");
          var hash = location.hash;
          location.hash = ''
          console.log("hashname: " + hash);
          console.log("hash removed");
        
        jQuery('html, body').animate({
            scrollTop: (jQuery(hash).offset().top - offsetamount)
          }, 800, function(){
            window.location.hash = '';
          });
        }
  
      jQuery('a[href*=\\#]').on('click', function (event) {
          if(this.pathname === window.location.pathname){
              event.preventDefault();
              var hash = this.hash;
          jQuery('html, body').animate({
              scrollTop: (jQuery(hash).offset().top - offsetamount)
              }, 800, function(){
              window.location.hash = '';
              });
          }
      }); 
  });
  